export default __webpack_public_path__ + "static/media/home-slider-1-comp.2241c2dc.png";